import { useEffect, useRef } from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { FINAL_FORM_ID, PHONE_LINK, PHONE_NUMBER } from '../lib/contactNavigation';

export const MobileContactBar = () => {
  const space = useRef(null);
  const bar = useRef(null);

  useEffect(() => {
    const documentRoot = document.documentElement;
    const previousHeight = documentRoot.style.getPropertyValue('--jos-contact-footer-height');
    const previouslyActive = documentRoot.hasAttribute('data-jos-contact-footer');
    const updateSpacing = () => {
      const height = bar.current?.getBoundingClientRect().height || 0;
      space.current?.style.setProperty('--jos-contact-bar-height', `${height}px`);
      documentRoot.style.setProperty('--jos-contact-footer-height', `${height}px`);
      documentRoot.toggleAttribute('data-jos-contact-footer', height > 0);
    };
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(updateSpacing) : null;
    updateSpacing();
    resize?.observe(bar.current);
    window.addEventListener('resize', updateSpacing);
    return () => {
      resize?.disconnect();
      window.removeEventListener('resize', updateSpacing);
      if (previousHeight) documentRoot.style.setProperty('--jos-contact-footer-height', previousHeight);
      else documentRoot.style.removeProperty('--jos-contact-footer-height');
      documentRoot.toggleAttribute('data-jos-contact-footer', previouslyActive);
    };
  }, []);

  return <div ref={space} className="jos-mobile-contact-space" data-testid="mobile-contact-spacing">
    <footer ref={bar} className="jos-mobile-contact-bar" data-testid="mobile-sticky-contact-bar" aria-label="Quick contact">
      <Button asChild className="jos-mobile-contact-button jos-mobile-consultation-button">
        <a href={`#${FINAL_FORM_ID}`} data-testid="mobile-sticky-consultation-button">
          <span data-testid="mobile-sticky-consultation-label">Book Consultation</span><ArrowRight size={18} aria-hidden="true" />
        </a>
      </Button>
      <Button asChild variant="outline" className="jos-mobile-contact-button jos-mobile-call-button">
        <a href={PHONE_LINK} aria-label={`Call ${PHONE_NUMBER}`} data-testid="mobile-sticky-call-button">
          <Phone size={18} aria-hidden="true" /><span data-testid="mobile-sticky-call-label">Call Now</span>
        </a>
      </Button>
    </footer>
  </div>;
};